import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import { exportImage } from '@progress/kendo-drawing';
import $ from "jquery";

var optionsTipoVasilha = [];

class DropDownCellTipoVasilha extends Component {
  
  static getAllData() {

    (async () => {

      optionsTipoVasilha = [];

      const data = {"IDInstalacaoVinica" : $('#instal_vinica_auto').val().split('!')[0]}
      const TipoVasilha = await services.apiCall.requestApi(
          "/Fiscalizacao/GetTipoVasilha",
          data,
          "get"
      );

      if(TipoVasilha != null){
        TipoVasilha.map((tipo) => (
          optionsTipoVasilha.push({text: tipo.tipoVasilha, value: tipo.idTipoVasilha})
        ));


      }
    })();


  }

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
  });
  }
  
  
  render() {
    console.log("Tipo de vasilhaaaaaa drop")
    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    // this.getAllData();

    return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
              popupSettings={{
                width: 'max-content',
              }}
              onChange={this.handleChange}
              value={optionsTipoVasilha.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
              data={optionsTipoVasilha}
              textField="text"
              id='id-DropDownCellTipoVasilha'
            />
            : dataValue != null ? dataValue.text.toString() : undefined}
        </td>
    );
  }
    
}

export default DropDownCellTipoVasilha;